import React, { useRef, useState, useEffect } from 'react';
import { bannerStyles as styles } from './UpcomingLiveGameBanner.tailwind';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import BannerCard from './BannerCard';
import { useSelector } from 'react-redux';


const UpcomingLiveGameBanner = () => {
  const scrollRef = useRef(null);
  const { liveMatches } = useSelector((state) => state.sport);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [showBanner, setShowBanner] = useState(true);

  const getScrollAmount = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 640) return 170;
    if (screenWidth < 1024) return 170;
    return 170;
  };

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  };

  const updateScrollButtons = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
  };

  useEffect(() => {
    updateScrollButtons();
    window.addEventListener('resize', updateScrollButtons);
    return () => window.removeEventListener('resize', updateScrollButtons);
  }, []);

  if (!showBanner) return null; // Hide the banner if closed

  return (
    <div className={styles.container}>
      {/* Marquee section */}
      <div className={styles.marqueeWrapper}>
        {/* Close Icon */}
        <button
          onClick={() => setShowBanner(false)}
          className={styles.closeIcon}
        >
          <CloseIcon
            sx={{ fontSize: 20 }}
          />
        </button>

        <marquee direction="left" className={styles.marqueeContainer}>
          {Array(10)
            .fill(0)
            .map((_, index) => (
              <span key={index} className={styles.marqueeText}>
                Game On - Tap to Join
              </span>
            ))}
        </marquee>
      </div>

      {/* Entire slider area including buttons */}
      <div className={`${styles.sliderWrapper}`}>
        {/* Left Scroll Button */}
        <button
          onClick={scrollLeft}
          className={`${!canScrollLeft ? styles.disabledButton : ''}`}
          disabled={!canScrollLeft}
        >
          <ChevronLeftIcon/> 
        </button>

        {/* Scrollable Card Section */}
        <div
          ref={scrollRef}
          onScroll={updateScrollButtons}
          className={styles.scrollableContent}
        >
          {liveMatches?.map((game) => (
            <div key={game.id}>
              <BannerCard data={game} />
            </div>
          ))}
        </div>

        {/* Right Scroll Button */}
        <button
          onClick={scrollRight}
          className={`${!canScrollRight ? styles.disabledButton : ''}`}
          disabled={!canScrollRight}
        >
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  );
};

export default UpcomingLiveGameBanner;
